import { render } from "./LocationForm.vue?vue&type=template&id=cfbdd2f4&scoped=true"
import script from "./LocationForm.vue?vue&type=script&lang=js"
export * from "./LocationForm.vue?vue&type=script&lang=js"

import "./LocationForm.vue?vue&type=style&index=0&id=cfbdd2f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfbdd2f4"]])

export default __exports__